<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCancel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{ "save" | translate }}</h4>
    </div>
    <div class="modal-body">
        <div class="form-group mb-20" [class.has-error]="name.invalid">
            <label class="control-label">
                {{ "page_name" | translate }}
            </label>

            <input
                class="form-control"
                type="text"
                autofocus
                [formControl]="name"
                spPageNameCheck
                [spPageNameOptions]="{ siteId, checkIfDirty: true }"
            />

            @if (pageNameAlreadyUsedError) {
                <p class="help-block small">
                    {{ "page_name_taken" | translate }}
                </p>
            }
        </div>

        <div class="form-group mb-20" [class.has-error]="pageUrl.invalid && pageUrl.dirty">
            <label class="control-label">
                {{ "control_url" | translate }}
            </label>

            <div class="input-group">
                <div class="input-group-addon overflow-url" [tooltip]="url$ | async" tooltipPlacement="top">
                    <span>{{ url$ | async }}</span>
                </div>
                <input
                    class="form-control"
                    type="text"
                    [formControl]="pageUrl"
                    spPageUrlCheck
                    [spPageUrlOptions]="{ siteId, checkIfDirty: true }"
                />
            </div>
            @if (pageUrl.dirty) {
                @if (pageUrlAlreadyExistsError) {
                    <p class="help-block small">
                        {{ "page_url_taken_error" | translate }}
                    </p>
                }
                @if (pageUrlInvalidError) {
                    <p class="help-block small">
                        {{ "page_url_invalid" | translate }}
                    </p>
                }
                @if (pageUrlReservedError) {
                    <p class="help-block small">
                        {{ "page_url_reserved" | translate }}
                    </p>
                }
            }
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" [disabled]="form.disabled" class="btn btn-default" (click)="onCancel()">
            {{ "cancel" | translate }}
        </button>

        <button
            type="button"
            [disabled]="form.invalid || form.pending || form.disabled"
            class="btn btn-success"
            (click)="onConfirm()"
        >
            {{ "save" | translate }}
        </button>
    </div>
</div>
